/**
 * @music-app/audio-engine-web
 *
 * Web implementation of the AudioPlayer interface using Tone.js.
 * Consumes AudioPlan data from @music-app/exercise-generator and renders it
 * via Web Audio API.
 */

export type {
  AudioPlayer,
  AudioPlayerOptions,
  AudioPlayerState,
  Instrument,
} from "./types.js";

export { TonePlayer } from "./tone-player.js";
export { midiToNoteName, midiToFrequency, gainToVelocity } from "./midi.js";
export { SAMPLE_SOURCES } from "./sample-sources.js";
export type { SampleSource } from "./sample-sources.js";
export {
  LatencyMonitor,
  measureLatency,
  DEFAULT_LATENCY_BUDGET_MS,
} from "./latency.js";
export type { LatencyMeasurement, LatencyMonitorOptions } from "./latency.js";

/** Create the default web audio player. Most apps just want this. */
import { TonePlayer } from "./tone-player.js";
import type { AudioPlayer } from "./types.js";

export function createAudioPlayer(): AudioPlayer {
  return new TonePlayer();
}
